import { useState, useMemo } from "react";

const allCities = [
  {
    name: "Altoona",
    route: "/cities/altoona-ia",
    tagline: "Polk County expedited passport services",
    highlights: ["Altoona area coverage", "Serving Des Moines metro"],
    badge: null,
    status: "live",
  },
  {
    name: "Ames",
    route: "/cities/ames",
    tagline: "Iowa State University & Story County passport hub",
    highlights: ["Iowa State University area", "Serving Story County"],
    badge: null,
    status: "live",
  },
  {
    name: "Ankeny",
    route: "/cities/ankeny",
    tagline: "Fastest-growing Des Moines suburb &amp; manufacturing hub",
    highlights: ["John Deere &amp; Casey's HQ area", "Serving DMACC &amp; northern Polk County"],
    badge: null,
    status: "live",
  },
  {
    name: "Bettendorf",
    route: "/cities/bettendorf",
    tagline: "Quad Cities expedited passport processing on the Mississippi",
    highlights: ["Quad Cities manufacturing &amp; riverfront", "Serving QC bi-state metro"],
    badge: null,
    status: "live",
  },
  {
    name: "Boone",
    route: "/cities/boone",
    tagline: "Scenic Valley Railroad &amp; Ledges State Park passport hub",
    highlights: ["Boone &amp; Scenic Valley Railroad area", "Serving Boone County &amp; DMACC"],
    badge: null,
    status: "live",
  },
  {
    name: "Burlington",
    route: "/cities/burlington-ia",
    tagline: "Snake Alley &amp; Mississippi River passport hub",
    highlights: ["Snake Alley &amp; Mississippi River region", "Serving Des Moines &amp; Lee counties"],
    badge: null,
    status: "live",
  },
  {
    name: "Cedar Rapids",
    route: "/cities/cedar-rapids",
    tagline: "Linn County's expedited passport hub",
    highlights: ["Linn County coverage", "Serving Marion, Hiawatha"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Clinton",
    route: "/cities/clinton-ia",
    tagline: "Gateway to Iowa &amp; US-30 Mississippi River hub",
    highlights: ["US-30 Mississippi River gateway", "Serving Clinton &amp; Jackson counties"],
    badge: null,
    status: "live",
  },
  {
    name: "Coralville",
    route: "/cities/coralville",
    tagline: "Iowa River Landing retail &amp; UIowa corridor hub",
    highlights: ["I-80 corridor &amp; Iowa River Landing", "Serving University of Iowa travelers"],
    badge: null,
    status: "live",
  },
  {
    name: "Council Bluffs",
    route: "/cities/council-bluffs",
    tagline: "Pottawattamie County & Omaha metro passport hub",
    highlights: ["Omaha metro area coverage", "Serving Southwest Iowa"],
    badge: null,
    status: "live",
  },
  {
    name: "Davenport",
    route: "/cities/davenport",
    tagline: "Quad Cities expedited passport processing",
    highlights: ["Quad Cities coverage", "Serving Bettendorf, Rock Island"],
    badge: null,
    status: "live",
  },
  {
    name: "Decorah",
    route: "/cities/decorah",
    tagline: "Vesterheim Norwegian heritage &amp; Luther College passport hub",
    highlights: ["Luther College &amp; Upper Iowa River Valley", "Serving Winneshiek &amp; Driftless Region"],
    badge: null,
    status: "live",
  },
  {
    name: "Des Moines",
    route: "/cities/des-moines",
    tagline: "Iowa's capital expedited passport hub",
    highlights: ["Polk County coverage", "Serving West Des Moines, Ankeny"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Dubuque",
    route: "/cities/dubuque",
    tagline: "Dubuque County & Tri-State region passport hub",
    highlights: ["Historic riverfront area", "Serving Tri-State region"],
    badge: null,
    status: "live",
  },
  {
    name: "Fort Dodge",
    route: "/cities/fort-dodge",
    tagline: "Gypsum capital &amp; North Central Iowa passport hub",
    highlights: ["Agribusiness &amp; medical processing center", "Serving Webster &amp; surrounding counties"],
    badge: null,
    status: "live",
  },
  {
    name: "Grinnell",
    route: "/cities/grinnell",
    tagline: "Grinnell College &amp; Poweshiek County expedited passport hub",
    highlights: ["Grinnell College study abroad hub", "Serving Poweshiek &amp; Central Iowa"],
    badge: null,
    status: "live",
  },
  {
    name: "Indianola",
    route: "/cities/indianola",
    tagline: "Simpson College &amp; Warren County south metro passport hub",
    highlights: ["Simpson College &amp; National Balloon Classic", "Serving Warren County &amp; Des Moines south metro"],
    badge: null,
    status: "live",
  },
  {
    name: "Iowa City",
    route: "/cities/iowa-city",
    tagline: "Johnson County university expedited passport hub",
    highlights: ["University of Iowa area", "Serving Coralville, North Liberty"],
    badge: null,
    status: "live",
  },
  {
    name: "Johnston",
    route: "/cities/johnston-ia",
    tagline: "Corteva/Pioneer &amp; Camp Dodge northwest metro passport hub",
    highlights: ["Corteva Agriscience &amp; Pioneer Hi-Bred HQ", "Serving Johnston-Grimes-Urbandale corridor"],
    badge: null,
    status: "live",
  },
  {
    name: "Keokuk",
    route: "/cities/keokuk",
    tagline: "Roquette America &amp; Mississippi River tri-state passport hub",
    highlights: ["Roquette &amp; Henniges Automotive hub", "Serving Lee County &amp; tri-state border region"],
    badge: null,
    status: "live",
  },
  {
    name: "Marion",
    route: "/cities/marion-ia",
    tagline: "Collins Aerospace &amp; Linn County Cedar Rapids metro hub",
    highlights: ["Collins Aerospace &amp; Uptown Marion district", "Serving Linn County &amp; Cedar Rapids metro"],
    badge: null,
    status: "live",
  },
  {
    name: "Marshalltown",
    route: "/cities/marshalltown",
    tagline: "Lennox International &amp; JBS manufacturing passport hub",
    highlights: ["Lennox &amp; JBS Swift manufacturing corridor", "Serving Marshall, Tama &amp; Grundy counties"],
    badge: null,
    status: "live",
  },
  {
    name: "Mason City",
    route: "/cities/mason-city",
    tagline: "River City music &amp; Frank Lloyd Wright architecture hub",
    highlights: ["MercyOne medical &amp; Music Man heritage", "Serving North Central Iowa"],
    badge: null,
    status: "live",
  },
  {
    name: "Muscatine",
    route: "/cities/muscatine",
    tagline: "HNI Corp &amp; Bayer Crop Science Mississippi River hub",
    highlights: ["HNI/Allsteel HQ &amp; Bayer Crop Science", "Serving Muscatine County &amp; Quad Cities corridor"],
    badge: null,
    status: "live",
  },
  {
    name: "Newton",
    route: "/cities/newton-ia",
    tagline: "TPI Composites &amp; Iowa Speedway Jasper County passport hub",
    highlights: ["TPI Composites wind energy &amp; Iowa Speedway", "Serving Jasper County &amp; I-80 corridor"],
    badge: null,
    status: "live",
  },
  {
    name: "North Liberty",
    route: "/cities/north-liberty",
    tagline: "Johnson County tech corridor &amp; Iowa City metro passport hub",
    highlights: ["I-380 corridor &amp; Centennial Park region", "Serving Johnson County &amp; UIowa commuters"],
    badge: null,
    status: "live",
  },
  {
    name: "Oskaloosa",
    route: "/cities/oskaloosa",
    tagline: "William Penn University &amp; Musco Lighting manufacturing hub",
    highlights: ["Musco Lighting &amp; Clow Valve region", "Serving Mahaska &amp; SE Central Iowa"],
    badge: null,
    status: "live",
  },
  {
    name: "Ottumwa",
    route: "/cities/ottumwa",
    tagline: "City of Bridges &amp; John Deere manufacturing passport hub",
    highlights: ["John Deere Works &amp; IHCC community", "Serving Wapello &amp; SE Iowa counties"],
    badge: null,
    status: "live",
  },
  {
    name: "Pella",
    route: "/cities/pella",
    tagline: "Dutch heritage &amp; Vermeer Corp passport hub",
    highlights: ["Central College &amp; Tulip Time region", "Serving Marion County &amp; Central Iowa"],
    badge: null,
    status: "live",
  },
  {
    name: "Sioux City",
    route: "/cities/sioux-city",
    tagline: "Woodbury County western Iowa passport hub",
    highlights: ["Woodbury County coverage", "Serving Tri-State area"],
    badge: null,
    status: "live",
  },
  {
    name: "Spencer",
    route: "/cities/spencer",
    tagline: "Iowa Great Lakes gateway &amp; Clay County Fair passport hub",
    highlights: ["Iowa Great Lakes &amp; Okoboji region", "Serving Clay &amp; Dickinson counties"],
    badge: null,
    status: "live",
  },
  {
    name: "Urbandale",
    route: "/cities/urbandale",
    tagline: "Insurance &amp; finance corridor Des Moines metro passport hub",
    highlights: ["I-35/80 corporate corridor", "Serving Urbandale-Johnston-Clive-Grimes"],
    badge: null,
    status: "live",
  },
  {
    name: "Waverly",
    route: "/cities/waverly",
    tagline: "Wartburg College &amp; GMT Corporation Cedar Valley passport hub",
    highlights: ["Wartburg College &amp; Bremer County region", "Serving Cedar Valley &amp; Northeast Iowa"],
    badge: null,
    status: "live",
  },
  {
    name: "Waterloo",
    route: "/cities/waterloo-ia",
    tagline: "Black Hawk County expedited passport hub",
    highlights: ["Waterloo-Cedar Falls area", "Serving UNI & John Deere travelers"],
    badge: null,
    status: "live",
  },
  {
    name: "West Des Moines",
    route: "/cities/west-des-moines",
    tagline: "Jordan Creek corporate &amp; insurance industry passport hub",
    highlights: ["Jordan Creek Town Center area", "Serving insurance &amp; finance professionals"],
    badge: null,
    status: "live",
  },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function IowaCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Iowa Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Iowa Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Iowa</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Iowa locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}